module.exports = __webpack_public_path__ + "static/assets/5047853e3a1bd267fb4dc6563d18a73a.svg";